module.exports = __webpack_public_path__ + "static/media/1.53f03edd.gif";